import { createContext, useContext } from 'react';
/**
 * Filter context to support searchable filters and collapsible filter groups.
 *
 * @public
 */
export const FilterGroupContext = createContext(null);
/**
 * A hook used to access the {@link Filters.FilterGroupContextType}.
 *
 * @public
 */
export function useFilterGroupContext() {
    const filterGroupContextInstance = useContext(FilterGroupContext);
    if (filterGroupContextInstance === null) {
        throw new Error('Tried to use FilterGroupContext when none exists.');
    }
    return filterGroupContextInstance;
}
//# sourceMappingURL=FilterGroupContext.js.map